import { TextColors } from '@/utils/constants';
import { makeStyles } from '@material-ui/core/styles';

const darkTheme = {
  root: {
    '& a': {
      color: `${TextColors.light} !important`,
      '& svg': {
        fill: `${TextColors.light} !important`,
      },
    },
    '& a:hover': {
      color: `${TextColors.light} !important`,
      '& svg': {
        fill: `${TextColors.light} !important`,
      },
    },

    '& $label': {
      '&.MuiTypography-root': {
        color: TextColors.light,
      },
    },
  },
};

const lightTheme = {
  root: {
    '& a': {
      color: `${TextColors.dark} !important`,
      '& svg': {
        fill: `${TextColors.dark} !important`,
      },
    },
    '& a:hover': {
      color: `${TextColors.dark} !important`,
      '& svg': {
        fill: `${TextColors.dark} !important`,
      },
    },

    '& $label': {
      '&.MuiTypography-root': {
        color: TextColors.dark,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,

      display: 'flex',
      flexDirection: 'row',
      marginTop: '24px',

      '& .at-resp-share-element .at-share-btn': {
        backgroundColor: 'transparent !important',
      },

      '& .at-resp-share-element': {
        '& .at-icon': {
          transition: 'fill 150ms linear',
          height: '24px !important',
          width: '24px !important',
        },
      },
      '& .social-icon': {
        width: '36px',
        height: '36px',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',

        '& .MuiSvgIcon-root': {
          width: '24px',
          height: 'fit-content',
        },

        '&.plus-icon': {
          '& .a2a_svg': {
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          '& svg': {
            width: '28px',
            height: 'fit-content',
          },
        },
      },
    },
    label: {
      '&.MuiTypography-root': {
        marginRight: muiTheme.spacing(0.5),
      },
    },
  }),
  { name: 'GenSocialShare' },
);

export default useStyles;
